{
  "$id": "wealthlane://forms/company-mapping/orch",
  "$schema": "wealthlane://schemas/form-orch",
  "layout": [
    {
      "rowId": "company_mapping_fields",
      "title": "",
      "fields": [
        {
          "scope": "#/properties/sourceCompanyId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 480
        },
        {
          "scope": "#/properties/destinationCompanyId",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 280,
          "maxWidthPx": 480
        }
      ]
    }
  ]
}
